/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import * as consts from '../../const.js';
import PropTypes from 'prop-types';
import Loading from '../../components/loading/loading.component';
import { Tabs, Tab, Clearfix } from 'react-bootstrap';
import NotesContainer from '../../components/notes/notes.container';
import Responses from '../../components/responses/responses-component';
import ConsentingJournal from './consenting.journal.page';
import ParticipantDetailsContainer from '../../components/participants/participant.details.container';
import Notification from '../../components/common/notification/notification.component';
import CDocuments from '../../components/documents/documents.container';

class ParticipantDetailsPage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.handleSelect(1);
    let participantJourneyGid = this.props.match.params.participantJourneyGid;
    this.props.fetchParticipantJourney(participantJourneyGid);
  }

  handleTabSelect = (key) => {
    this.props.handleSelect(key);
  };

  render() {
    if (this.props.error)
      return (
        <div>
          <h3 className="participant-details-title page-title">{consts.STUDY_PARTICIPANT}</h3>
          <Notification type="error" data={this.props.error} />
        </div>
      );

    /**
     * If state is null then means that the page is redirected by sso after login
     * This means that the breadcrumb state will be undefined so here in order to provide the values for
     * breadcrumb state, we use the history.push to redirect to same location adding the values to state
     */
    if (null == this.context.router.route.location.state) {
      const { organizationId = '', organizationName = '' } = this.props.match.params;

      if (this.props.isFetching) {
        return <Loading />;
      } else {
        this.context.router.history.push(this.context.router.route.location.pathname, {
          forBreadcrumb: {
            participantJourneyGid: this.props.match.params.participantJourneyGid,
            studyName: this.props.participantStudy.name,
            studyGid: this.props.participantStudy.gid,
            participantName: this.props.participantJourney.participantUsername,
            organizationId,
            organizationName
          }
        });
      }
    }

    return (
      <div>
        <h3 className="participant-details-title page-title">{consts.STUDY_PARTICIPANT}</h3>
        <ParticipantDetailsContainer />
        <Tabs activeKey={this.props.tab} onSelect={this.handleTabSelect} id="participantId">
          <Clearfix />
          <Tab eventKey={1} title={consts.DOCUMENTS}>
            <CDocuments />
          </Tab>
          <Tab eventKey={2} unmountOnExit title={consts.NOTES}>
            <NotesContainer />
          </Tab>
          <Tab eventKey={3} unmountOnExit title={consts.CONSENTING_JOURNAL}>
            <ConsentingJournal />
          </Tab>
          <Tab eventKey={4} unmountOnExit title={consts.RESPONSES}>
            <Responses />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

ParticipantDetailsPage.contextTypes = {
  router: PropTypes.object.isRequired
};

ParticipantDetailsPage.propTypes = {
  handleSelect: PropTypes.func,
  match: PropTypes.object,
  fetchParticipantJourney: PropTypes.func,
  error: PropTypes.object,
  isFetching: PropTypes.bool,
  participantStudy: PropTypes.object,
  participantJourney: PropTypes.object,
  tab: PropTypes.number
};

export default ParticipantDetailsPage;
